import dayjs from "dayjs";
import { Winner, WinnerCategories } from "./types";

export const SUBSCRIBER_COMPETITION_KEY = "Subscriber Competition";

// Convert a category Key (e.g. "Big wins") into a URL slug (e.g. "big-wins").
// Prefer the API-provided Link when it already looks like our route shape,
// otherwise kebab-case the Key as a deterministic fallback.
export const categoryToSlug = (category: WinnerCategories): string => {
  const linkLast = category.Link?.split("/").filter(Boolean).pop();
  if (linkLast) return linkLast;

  return category.Key.toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
};

export const findCategoryBySlug = (categories: WinnerCategories[], slug: string): WinnerCategories | undefined =>
  categories.find(c => categoryToSlug(c) === slug);

export const filterWinnersByCategory = (winners: Winner[], categoryKey: string): Winner[] =>
  winners.filter(w => w.WinnerCategories?.includes(categoryKey));

export const CATEGORY_ROUTE_PREFIX = "/winners/category/";

export const buildCategoryHref = (category: WinnerCategories): string =>
  `${CATEGORY_ROUTE_PREFIX}${categoryToSlug(category)}`;

const getMatch = (date: string) => {
  const matches = /([0-9]+)/g.exec(date);
  if (matches) {
    const match = matches[0];
    return match;
  }
  return null;
};

const formatDate = (match: string) => {
  if (match) {
    return dayjs(Number(match)).format("DD MMM YYYY");
  }
  return null;
};

export const getFormattedDate = (winner: Winner) => {
  if (winner.FirstPublishedDate) {
    return formatDate(getMatch(winner.FirstPublishedDate));
  }
  return winner.CompetitionDateRange;
};
